import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useCityOptions = () => {
  const {
    data: cityOptions,
    isLoading: isCityOptionsLoading,
    refetch: refetchCityOptions,
  } = useQuery({
    queryKey: ["cityOptions"],
    queryFn: () => dropdownService.getCityOptions(),
  });

  return {
    cityOptions: cityOptions || [],
    isCityOptionsLoading,
    refetchCityOptions,
  };
};
